import { Image, Row } from "antd";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";

const LoginHeader = ({ open, setOpen }) => {
    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });

    return (
        <Row
            style={{
                width: "100%",
                display: "flex",
                backgroundColor: "rgb(28, 35, 71)",
                justifyContent: "center",
                borderBottomLeftRadius: !isLargeScreen ? "0px" : "12px",
                borderBottomRightRadius: !isLargeScreen ? "0px" : "12px",
                textAlign: "center",
                minHeight: "50px",
                padding: "10px 0px",
            }}>
            <Link to={"/login"}>
                <Image
                    src={"/logo_bianco.png"}
                    style={{
                        width: "50%",
                        margin: isLargeScreen ? "2em" : "0 auto",
                    }}
                    preview={false}
                />
            </Link>
        </Row>
    );
};

export { LoginHeader };
